module.exports = __webpack_public_path__ + "img/baziyoung.83d59cc5.png";